
import lazyload from "@/directives/lazyload";

import cam4 from "@/assets/images/main/example/cam/cam4.png"
import camscom from "@/assets/images/main/example/cam/camscom.png"
import extreme from "@/assets/images/main/example/cam/extreme.png"
import home from "@/assets/images/main/example/cam/home.png"
import keezlive from "@/assets/images/main/example/cam/keezlive.png"
import kink from "@/assets/images/main/example/cam/kink.png"
import live from "@/assets/images/main/example/cam/live.png"
import porntube from "@/assets/images/main/example/cam/porntube.png"
import streamate from "@/assets/images/main/example/cam/streamate.png"
import tube8 from "@/assets/images/main/example/cam/tube8.png"

export default {
  data() {
    return {
      images: {
        cam4,
        camscom,
        extreme,
        home,
        keezlive,
        kink,
        live,
        porntube,
        streamate,
        tube8
      },
    };
  },
  directives: {
    lazyload,
  },
};
